import { queryFetch } from '../../api';
import { useMutation } from '@tanstack/react-query';
import { ExternalScheduleReq, ExternalScheduleRespSuccess } from './types';
import { useJobRefetch } from '@hooks/job/refetch';

export const useUpdateExternalSchedule = ({
  callback,
}: {
  callback: (data: ExternalScheduleRespSuccess) => void;
}) => {
  const { refetch } = useJobRefetch({ schedule: { type: 'external', action: 'update' } });

  const { mutate, isPending } = useMutation({
    mutationFn: ({
      jobId,
      scheduleId,
      ...data
    }: ExternalScheduleReq): Promise<ExternalScheduleRespSuccess> =>
      queryFetch({
        url: `jobs/${jobId}/external_schedules/${scheduleId}/reschedule`,
        data,
        opt: { method: 'POST' },
      }),
    onError: (err) => {
      console.error(err);
    },
    onSuccess: async ({ success }) => {
      if (!success) return;
      await refetch();
    },
    onSettled: (data) => {
      callback(data as ExternalScheduleRespSuccess);
    },
  });

  return {
    mutate,
    isLoading: isPending,
  };
};
